import { UpdateSendNotificationFlagInput } from '../GlobalTypes'
import { apolloClient } from '../apolloClient'
import { UPDATE_SEND_NOTIFICATION } from './mutations/UPDATE_SEND_NOTIFICATION'
import { UpdateSendNotification, UpdateSendNotificationVariables } from '../types/UpdateSendNotification'
import { setGlobal } from '../../global/useGlobal'

export const updateSendNotification = async (input: UpdateSendNotificationFlagInput) => {
  const response = await apolloClient.mutate<UpdateSendNotification, UpdateSendNotificationVariables>({
    mutation: UPDATE_SEND_NOTIFICATION,
    variables: { input: input },
  })

  if (response) {
    setGlobal({
      updateSendNotification: response.data?.updateSendNotificationFlag?.message,
    })
  }
}
